import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import TextInput from './TextInput';
import { fetchAresData } from '../store/actions';
import T from './Translate';

class AresInput extends Component {

	state = {
		isLoading: false,
	};

	handleAres = async (e) => {
		e.preventDefault();

		this.setState({ isLoading: true });

		const response = await this.props.dispatch(fetchAresData());

		if (response) {
			alert(response);
		}

		this.setState({ isLoading: false });
	};

	render() {

		return (
			<div className="width-100 relative">
				<TextInput {...this.props} />

				{!this.state.isLoading &&
				<button className="large-input__ares" onClick={this.handleAres}><T id="AresInput.button" /></button>
				}

				{this.state.isLoading &&
				<div className="loader large-input__loader"/>
				}
			</div>
		);

	}
}

export default compose(
	connect(),
)(AresInput);



// WEBPACK FOOTER //
// ./src/components/AresInput.jsx